module.exports = __webpack_public_path__ + "../resources/img/ic_plus.0d7a44cc.svg";